export default "__VITE_ASSET__3b3215e4__"